"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonSaveTripSegmentsConfig = void 0;
const helpers_1 = require("../../../../utils/helpers");
const odHelpers = __importStar(require("../../../odSurvey/helpers"));
const getButtonSaveTripSegmentsConfig = (
// FIXME: Type this when there is a few more widgets implemented
options) => {
    // TODO These should be some configuration receive here to fine-tune the section's content
    return {
        type: 'button',
        color: 'green',
        label: (t) => t(['customSurvey:segments:SaveTripLabel', 'segments:SaveTripLabel']),
        hideWhenRefreshing: true,
        path: 'buttonSaveTrip',
        // FIXME This requires dependencies
        icon: options.iconMapper['check-circle'],
        align: 'center',
        action: options.buttonActions.validateButtonAction,
        saveCallback: (callbacks, interview, path) => {
            // Set all segments' _isNew to false and select the next trip ID as the active one
            const updateValuesbyPath = {};
            const segmentsPath = (0, helpers_1.getPath)(path, '../segments');
            const segments = (0, helpers_1.getResponse)(interview, segmentsPath, {});
            // set segments as not new:
            for (const segmentUuid in segments) {
                const segment = segments[segmentUuid];
                segment._isNew = false;
                const segmentPath = `${segmentsPath}.${segmentUuid}`;
                updateValuesbyPath[`response.${segmentPath}._isNew`] = false;
            }
            const journey = odHelpers.getActiveJourney({ interview });
            const nextTrip = journey !== null ? odHelpers.selectNextIncompleteTrip({ journey }) : null;
            updateValuesbyPath['response._activeTripId'] = nextTrip ? nextTrip._uuid : null;
            callbacks.startUpdateInterview({ sectionShortname: 'segments', valuesByPath: updateValuesbyPath });
        },
        conditional: function (interview, path) {
            const segments = (0, helpers_1.getResponse)(interview, path, {}, '../segments');
            const segmentsArray = Object.values(segments).sort((segmentA, segmentB) => {
                return segmentA['_sequence'] - segmentB['_sequence'];
            });
            const lastSegment = segmentsArray[segmentsArray.length - 1];
            return [lastSegment !== undefined && lastSegment.hasNextMode === false, undefined];
        }
    };
};
exports.getButtonSaveTripSegmentsConfig = getButtonSaveTripSegmentsConfig;
//# sourceMappingURL=buttonSaveTripSegments.js.map